import { render } from "./IconPhelcom.vue?vue&type=template&id=3c5646b6&lang=html"
import script from "./IconPhelcom.vue?vue&type=script&lang=js"
export * from "./IconPhelcom.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__